<div class="flex w-full flex-col gap-1 text-sm">
  @if (label()) {
    <span class="block self-start text-sm text-(--ig-editor-text-color,#ffffff)">{{ label() }}</span>
  }

  <div
    class="flex h-(--ig-editor-field-height,2.33em) w-full items-stretch overflow-hidden rounded-(--ig-editor-field-radius,6px) text-sm bg-(--ig-editor-field-bg,#2b2e32)">
    <div class="flex min-w-0 flex-1 items-center">
      <input
        #input
        type="number"
        class="min-w-0 flex-1 h-full m-0 border-0 bg-transparent py-0 pl-2 pr-1 text-right text-sm leading-7.5 text-(--ig-editor-text-color,#ffffff) focus:outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        [value]="value()"
        [min]="min()"
        [max]="max()"
        (click)="input.select()"
        (change)="applyValue($event)" />

      @if (unit()) {
        <span class="shrink-0 select-none px-1 text-xs font-semibold text-(--ig-editor-text-color,#ffffff)">
          {{ unit() }}
        </span>
      }
    </div>

    <div class="flex items-center self-center pr-1">
      <button
        type="button"
        class="flex size-[calc(var(--ig-editor-field-height,2.33em)-10px)] items-center justify-center rounded-full border-0 bg-transparent p-0 text-(--ig-editor-text-color,#ffffff) transition-colors cursor-pointer hover:enabled:bg-white/10 disabled:cursor-default disabled:opacity-30"
        [disabled]="(value() ?? 0) <= min()"
        tabindex="-1"
        libAutoclicker="100"
        (autoclick)="dec()">
        <span class="block h-0.5 w-2.5 rounded-full bg-current" aria-hidden="true"></span>
      </button>

      <button
        type="button"
        class="flex size-[calc(var(--ig-editor-field-height,2.33em)-10px)] items-center justify-center rounded-full border-0 bg-transparent p-0 text-sm font-semibold leading-none text-(--ig-editor-text-color,#ffffff) transition-colors cursor-pointer hover:enabled:bg-white/10 disabled:cursor-default disabled:opacity-30"
        [disabled]="(value() ?? 0) >= max()"
        tabindex="-1"
        libAutoclicker="100"
        (autoclick)="inc()">
        +
      </button>
    </div>
  </div>
</div>
